import { ref as s, watchEffect as y, onMounted as _, onBeforeUnmount as k, defineComponent as E, useAttrs as S, useSlots as P, computed as C, watch as M, openBlock as v, createElementBlock as h, normalizeClass as A, unref as r, createElementVNode as I, renderSlot as w, withDirectives as z, vShow as N, createCommentVNode as B } from "vue";
import { onClickOutside as O } from "@vueuse/core";
const c = "data-balloon-pos", D = "[data-balloon-pos]";
function H(i) {
  const o = i.querySelector(D);
  let e;
  return o && (e = o.getAttribute(c)), {
    hide() {
      o && o.removeAttribute(c);
    },
    show() {
      o && o.setAttribute(c, e);
    },
    visible(t) {
      t ? this.show() : this.hide();
    }
  };
}
function U() {
  const i = s(!1), o = s(null);
  let e;
  return y(() => {
    e && e.visible(!i.value);
  }), _(() => {
    o.value && (e = H(o.value));
  }), k(() => {
    e && (e = void 0);
  }), {
    visible: i,
    myElement: o
  };
}
const L = /* @__PURE__ */ E({
  __name: "HeaderDropdown",
  props: {
    /**
      * 触发 popper 出现的方式。默认为 click，可选值：click ｜ hover
    */
    trigger: {
      type: String,
      default: "click"
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    showTimeout: {
      type: Number,
      default: 250
    },
    isShowPopoverImmediate: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(i, { emit: o }) {
    const e = i, { visible: t, myElement: d } = U(), T = S(), m = P(), b = C(() => T.align || "right"), a = s(0), u = s(0), l = () => {
      t.value = !1;
    };
    O(d, l);
    const g = () => {
      if (e.trigger !== "hover") {
        t.value = !t.value;
        return;
      }
      o("click", { visible: t.value, close: l });
    }, f = () => {
      e.trigger === "hover" && (clearTimeout(u.value), clearTimeout(a.value), a.value = window.setTimeout(() => {
        t.value = !1;
      }, e.hideTimeout));
    }, p = () => {
      e.trigger === "hover" && (clearTimeout(a.value), clearTimeout(u.value), u.value = window.setTimeout(() => {
        t.value = !0;
      }, e.showTimeout));
    };
    return M(
      () => e.isShowPopoverImmediate,
      (n) => {
        n && p();
      },
      { immediate: !0 }
    ), (n, R) => (v(), h("div", {
      ref_key: "myElement",
      ref: d,
      class: A(["patsnap-biz-header-dropdown", [
        {
          "patsnap-biz-header-dropdown--opened": r(t)
        },
        b.value
      ]])
    }, [
      I("div", {
        class: "patsnap-biz-header-dropdown__reference",
        onMouseenter: p,
        onMouseleave: f,
        onClick: g
      }, [
        w(n.$slots, "reference", {
          open: r(t),
          close: l
        })
      ], 32),
      r(m).popper || r(m).popper ? z((v(), h("div", {
        key: 0,
        ref: "popper",
        class: "patsnap-biz-header-dropdown__popper",
        onMouseenter: p,
        onMouseleave: f
      }, [
        w(n.$slots, "popper", {
          open: r(t),
          close: l
        })
      ], 544)), [
        [N, r(t)]
      ]) : B("", !0)
    ], 2));
  }
}), q = L;
export {
  q as PtHeaderDropdown,
  q as default
};
